exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".row.header[data-v-43c628e2]{margin-bottom:15px;margin-top:10px}.row.body[data-v-43c628e2]{padding-left:55px;margin-bottom:10px}.info-item-wrapper[data-v-43c628e2]{margin-bottom:45px}[data-v-43c628e2] .disabled-overlay{opacity:0.2}[data-v-43c628e2] ::placeholder{color:#9B9C9D;opacity:0.75}\n", ""]);

